module.exports = __webpack_public_path__ + "static/media/nutritionist-mobile-cover.70d83319.png";